/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zesty_Bald_Bullock_ListInputs */

const en_zesty_bald_bullock_list = /** @type {(inputs: Zesty_Bald_Bullock_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short`)
};

/**
* | output |
* | --- |
* | "Short" |
*
* @param {Zesty_Bald_Bullock_ListInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const zesty_bald_bullock_list = /** @type {((inputs?: Zesty_Bald_Bullock_ListInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zesty_Bald_Bullock_ListInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_zesty_bald_bullock_list(inputs)
});